import { AxiosPromise } from 'axios';
import { csttFacadeApi } from '../csttFacadeApi';

const functionsList = (): AxiosPromise => csttFacadeApi.get(`/csttfacade/tsguide/v1/functions`);
const deleteFunction = (id: string): AxiosPromise => csttFacadeApi.delete(`/csttfacade/tsguide/v1/functions/${id}`);
const addFunction = (data: any): AxiosPromise => csttFacadeApi.post(`/csttfacade/tsguide/v1/functions`, data);


export { functionsList, deleteFunction, addFunction }